import 'bootstrap';
import Masonry from 'masonry-layout';
import imagesLoaded from 'imagesloaded';

import './components/slider/slider';
import './components/sample-tile-order/sample-tile-order';
import './components/retailer-search/retailer-search';
import './components/content-media-library/content-media-library';
import './components/tabs/tabs';

import '../styles/index.scss';

///
// Backdrop for main menu
///

import {manageDropdownHover} from './components/navi/navi.js';

document.addEventListener('DOMContentLoaded', () => {
  manageDropdownHover();

  const backdrop = document.querySelector(".backdrop");
  const dropdowns = document.querySelectorAll(".dropdown");
  let openDropdowns = [];

  dropdowns.forEach(dropdown => {
    dropdown.addEventListener("show.bs.dropdown", () => {
      openDropdowns.push(dropdown);
      backdrop.style.display = "block";
    });

    dropdown.addEventListener("hidden.bs.dropdown", () => {
      openDropdowns.splice(openDropdowns.indexOf(dropdown), 1);
      if (openDropdowns.length === 0) {
        backdrop.style.display = "none";
      }
    });
  });
})
;

///
// Header
///
window.addEventListener('scroll', () => {
  const header = document.querySelector('.page__header');
  if (window.pageYOffset > 1) {
    header.classList.add('page__header--default');
  } else {
    header.classList.remove('page__header--default');
  }
});


///
// Masonry layout
///

// Function to initialize Masonry layout with imagesLoaded support
const initMasonry = () => {
  const grid = document.querySelector('.stories-list');
  if (!grid) return;

  const masonry = new Masonry(grid, {
    itemSelector: '.stories-list__item',
    columnWidth: '.stories-list__item',
    percentPosition: true,
  });

  // Ensure images are loaded before Masonry layout
  imagesLoaded(grid).on('progress', () => {
    masonry.layout();
  });

  document.addEventListener('facetwp-loaded', () => {
    masonry.reloadItems();
    imagesLoaded(grid).on('progress', () => {
      masonry.layout();
    });
  });
};

initMasonry();
